import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useLocalStorage } from "../hooks/useLocalStorage";
// import styles from "../style/page/dashboard.module.scss";
// import Popup from "../component/Popup";
// import Matrix from "../component/Matrix";
// import Floorplan from "../component/Floorplan";
// import HeaderTitle from "../component/HeaderTitleComponent";
// import { useNavigate } from "react-router-dom";
// import ButtonComponent from "../component/ButtonComponent/";
// import LoadingComponent from "../component/LoadingComponent";
// import { logoutSuccess } from "../actions";
// import { useDispatch } from "react-redux";
// import { useTranslation } from "react-i18next";

const Dashboard = ({}) => {
    // const { t } = useTranslation();
    // const [loading, setLoading] = useState(false);

    // return (
    //     <>
    //         {loading && <LoadingComponent />}
    //         <div className={styles.dashboard}>
    //             <div className="container-wrapper" style={{ maxWidth: "unset" }}>
    //                 <HeaderTitle title={`Dashboard`} colorTitle="#0000FF" colorLine="#0000FF" moreClass="unit-matrix" />
    //             </div>
    //         </div>
    //     </>
    // );

    // return (
    //     <div
    //         style={{
    //             padding: 24,
    //             minHeight: 360,
    //         }}
    //     >
    //         Dashboard
    //     </div>
    // );

    const { userData } = useLocalStorage();

    if (userData && userData.role === "super_admin") {
        return <Navigate to="/users/teacher" replace />;
    } else {
        return <Navigate to="/course" replace />;
    }
};

export default Dashboard;
